<template>
  <div>
    <filter-bar
      name="subscribers"
      :filters="filters"
      @reset="reset"
      @filtrer="filtrer"
      @search="search"
    ></filter-bar>

    <div class="min-h-screen flex-1 mt-1 bg-gray-100 px-3 items-center">
      <div class="bg-white w-fullrounded-lg shadow">
        <div class="h-20 py-3 flex items-center border-gray-200 p-6">
          <div class="flex">
            <div class="text-2xl font-bold text-primary-700">
              {{ $t('subscribers') }}
            </div>
          </div>

          <div class="w-full flex items-center justify-end gap-4">
            <router-link
              class="flex rounded focus:outline-none outline-none text-gray-100 px-3 w-1/7 py-2 bg-primary-600 hover:shadow-inner hover:bg-primary-700 transition-all duration-300"
              to="/subscribers/new"
            >
              <i class="material-icons">add</i> {{ $t('new') }}
            </router-link>

            <div
              v-if="currentUser.type == 'CEO'"
              @click="downloadSubscribers"
              class="flex rounded focus:outline-none outline-none text-gray-100 px-3 w-1/7 py-2 bg-primary-600 hover:shadow-inner hover:bg-primary-700 transition-all duration-300"
            >
              <i class="material-icons">file_download</i> csv
            </div>
          </div>
        </div>

        <div>
          <base-table
            :refresh="refresh"
            :content="content"
            :headers="headers"
            name="subscribers"
          >
          </base-table>
        </div>

        <div class="p-1">
          <div class="flex flex-col items-center my-2">
            <div v-if="paginate.lastpage > 1" class="flex text-gray-700">
              <button
                v-if="paginate.currentpage > 1"
                @click="paginatation('prev')"
                :disabled="paginate.currentpage == 1"
                class="h-8 w-8 focus:outline-none mr-6 flex justify-center text-primary-700 items-center rounded-full bg-gray-200 hover:bg-primary-600 hover:text-white cursor-pointer"
              >
                <i class="material-icons"> keyboard_arrow_left </i>
              </button>

              <div class="flex h-8 font-medium rounded-full bg-gray-200">
                <div
                  v-if="paginate.currentpage != paginate.lastpage"
                  class="w-8 md:flex justify-center items-center hidden cursor-pointer leading-5 transition duration-150 ease-in rounded-full bg-primary-600 text-white"
                >
                  {{ paginate.currentpage }}
                </div>

                <div
                  v-else
                  class="w-8 md:flex justify-center items-center hidden cursor-pointer leading-5 transition duration-150 ease-in rounded-full"
                >
                  <span v-if="paginate.currentpage != 1"> 1 </span>
                </div>

                <div
                  v-if="paginate.currentpage >= 1 && paginate.lastpage != 1"
                  class="w-8 md:flex justify-center items-center hidden cursor-pointer leading-5 transition duration-150 ease-in rounded-full"
                >
                  ...
                </div>

                <button
                  :class="
                    paginate.currentpage == paginate.lastpage
                      ? 'bg-primary-600  text-white'
                      : ' '
                  "
                  class="w-8 md:flex justify-center items-center hover:bg-primary-600 hover:text-white focus:outline-none hidden cursor-pointer leading-5 transition duration-150 ease-in rounded-full"
                >
                  {{ paginate.lastpage }}
                </button>
              </div>

              <button
                v-if="paginate.currentpage < paginate.lastpage"
                :disabled="paginate.currentpage == paginate.lastpage"
                @click="paginatation('next')"
                class="h-8 w-8 ml-6 focus:outline-none flex justify-center text-primary-700 items-center rounded-full bg-gray-200 hover:bg-primary-600 hover:text-white cursor-pointer"
              >
                <i class="material-icons"> keyboard_arrow_right </i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubscriberList',
  data() {
    return {
      content: [],
      headers: [
        'fullName',
        'phone',
        'city',
        'createdAt',
        'source',
        'email',
        'notes',
        'isConverted',
      ],
      IsConverted: ['Converted', 'Non Converted'],
      limit: 10,
      filter: {},
      loading: false,
      filtersData: {},
      paginate: {
        total: 0,
        currentpage: 1,
        lastpage: 0,
        per_page: 0,
      },
      filters: {
        name: 'subscribers',
        elements: {
          search: {
            options: {
              icon: 'search',
              label: 'search',
              class: '',
              hint: 'search_subscriber',
            },
            value: null,
            type: 'search',
            validate: {
              trim: true,
              required: false,
              minlength: 0,
            },
          },
          champs: [
            {
              label: 'Note',
              key: 'notes',
              name: 'notes',
              value: null,
              values: [],
              class:
                'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
              type: 'select',
            },
            {
              label: 'converted',
              key: 'isConverted',
              name: 'isConverted',
              value: null,
              values: [],
              class:
                'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
              type: 'select',
            },
            {
              label: 'date',
              key: 'date',
              value: null,
              placeholder: 'Date',
              type: 'date',
              class: 'py-2 text-xs px-2 outline-none block h-full w-full',
            },
          ],
        },
      },
      currentUser: {
        role: {},
      },
    };
  },
  async mounted() {
    await this.getUser();

    if (this.$f.QueryStringToobject())
      this.filtersData = this.$f.QueryStringToobject();
    else
      this.$f.objectToQueryString({
        limit: this.limit,
        country: await this.warhouseSelected,
      });

    if (this.filtersData.name) await this.search(this.filtersData.name);
    else await this.getSubscribers(this.filtersData);

    for (var i = 0; i < this.filters.elements.champs.length; i++) {
      if (this.filters.elements.champs[i].key === 'isConverted')
        this.filters.elements.champs[i].values = this.IsConverted;
      if (this.filters.elements.champs[i].key === 'notes')
        this.filters.elements.champs[i].values = [
          'Numéro invalide ou suspendu',
          'Boite vocale',
          'A rappeler',
          'Ne répond pas',
          'Autre',
        ];
    }
  },
  computed: {
    warhouseSelected() {
      return this.$store.getters['wharhouse/warhouseSelected'];
    },
  },
  watch: {
    warhouseSelected: async function(oldVal, newVal) {
      await this.reset();
    },
  },
  methods: {
    async getUser() {
      const res = await this.$server.me('users');
      if (res.content) this.currentUser = res.content;
      else this.currentUser = {};
    },
    async getSubscribers(filter) {
      filter['country'] = await this.warhouseSelected;
      this.loading = true;
      const res = await this.$server.search('subscribers', filter);
      this.loading = false;
      if (res.content && res.content.results) {
        this.content = res.content.results;
        this.paginate.total = res.content.total;
        this.paginate.lastpage = res.content.last_page;
        this.paginate.per_page = res.content.per_page;
        this.paginate.currentpage = res.content.current_page;
      } else {
        this.content = [];
      }
    },

    async refresh() {
      if (this.$f.QueryStringToobject())
        this.filtersData = this.$f.QueryStringToobject();
      this.$f.objectToQueryString(this.filtersData);
      if (this.filtersData.name) await this.search(this.filtersData.name);
      else await this.getSubscribers(this.filtersData);
      if (
        this.filtersData['page'] &&
        this.filtersData['page'] > 1 &&
        this.content.length == 0
      ) {
        this.filtersData['page'] = --this.filtersData['page'];
        this.$f.objectToQueryString(this.filtersData);
        await this.getSubscribers(this.filtersData);
      }
    },

    async search(data) {
      let search = { name: data.trim() };
      search.country = await this.warhouseSelected;
      this.$f.objectToQueryString(search);
      this.loading = true;
      const res = await this.$server.find('subscribers', search);
      this.loading = false;
      if (res.content) {
        this.content = res.content;
        // this.paginate.total = res.content.total;
        // this.paginate.lastpage = res.content.last_page;
        // this.paginate.per_page = res.content.per_page;
        // this.paginate.currentpage = res.content.current_page;
      } else {
        this.content = [];
        this.paginate = { total: 0, currentpage: 1, lastpage: 1, per_page: 0 };
      }
    },

    async reset(data) {
      console.log('is reset');
      let lmitt = this.limit;
      if (this.$f.QueryStringToobject())
        this.filtersData = this.$f.QueryStringToobject();
      if (this.filtersData['limit']) lmitt = this.filtersData['limit'];
      this.filtersData['page'] = 1;
      this.$f.objectToQueryString({
        limit: lmitt,
        country: await this.warhouseSelected,
      });
      await this.getSubscribers({ limit: lmitt });
    },
    async filtrer(data) {
      console.log('data)-------', data);
      if (this.$f.QueryStringToobject())
        this.filtersData = this.$f.QueryStringToobject();
      delete this.filtersData.page;
      delete this.filtersData.name;
      this.paginate.currentpage = 1;
      if (!this.filtersData['limit']) this.filtersData['limit'] = this.limit;
      if (data.isConverted) this.filtersData.isConverted = data.isConverted;
      else delete data.isConverted;
      //if (data.date) this.filtersData.date = data.date;else delete data.date;
      if (data.date && data.date[0]) {
        this.filtersData.date = data.date.map(el =>
          this.$moment(el).format('yyyy-MM-DD'),
        );
      } else delete this.filtersData.date;
      if (data.notes) this.filtersData.notes = data.notes;
      else delete data.notes;
      this.$f.objectToQueryString(this.filtersData);
      await this.getSubscribers(this.filtersData);
    },
    /*********************************************************************************/

    async paginatation(direction) {
      var page = 0;
      if (direction == 'next') {
        page = ++this.paginate.currentpage;
      } else {
        page = --this.paginate.currentpage;
      }
      if (this.$f.QueryStringToobject())
        this.filtersData = this.$f.QueryStringToobject();
      this.filtersData['page'] = page;
      this.$f.objectToQueryString(this.filtersData);
      this.getSubscribers(this.filtersData);
    },
    async downloadSubscribers() {
      //
      this.filter['country'] = await this.warhouseSelected;
      if (this.filter.isConverted) {
        if (this.filter.isConverted === 'Non Converted')
          this.filter.isConverted = false;
        else this.filter.isConverted = true;
      }
      this.loading = true;
      const res = await this.$server.export('subscribers', this.filter);
      this.loading = false;
      //
      if (res && res.content) {
        let link = window.document.createElement('a');
        link.setAttribute(
          'href',
          'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(res.content),
        );
        link.setAttribute('download', 'subscribers.csv');
        link.click();
      }
    },
  },
};
</script>

<style></style>
